<template>
  <CRow>
    <CCol md="12" style="font-size: 14px; margin-bottom: 80px;">
      <CDataTable
        :items="items"
        :fields="fields"
        :items-per-page="30"
        hover
        striped
        border
        small
        fixed
        pagination
        :table-filter="{ label: 'Buscar: ', placeholder: '...' }"
        :noItemsView="{ noResults: 'No se encontraron elementos', noItems: 'Sin invitados en Black List' }"
      >
        <template #position="{ item }">
          <td class="text-center" style="font-size: 12px;">{{ item.position }}</td>
        </template>

        <template #name="{ item }">
          <td class="text-left" style="font-size: 12px;"><b>{{ item.name }}</b></td>
        </template>

        <template #last_name="{ item }">
          <td class="text-left" style="font-size: 12px;"><b>{{ item.last_name }}</b></td>
        </template>

        <template #nickname="{ item }">
          <td class="text-left" style="font-size: 12px;">{{ item.nickname }}</td>
        </template>

        <template #phone="{ item }">
          <td class="text-center" style="font-size: 12px;">{{ item.phone }}</td>
        </template>

        <template #email="{ item }">
          <td class="text-center" style="font-size: 12px;">{{ item.email }}</td>
        </template>

        <template #blacklist_date_human="{ item }">
          <td class="text-center" style="font-size: 12px;">{{ item.blacklist_date_human }}</td>
        </template>
      </CDataTable>
    </CCol>
  </CRow>
</template>

<script>
import ws from '@/services/events_guests';
import store from '@/store';

export default {
  name: 'BlacklistModule',
  props: {
    event: { type: Object, required: true }
  },
  data() {
    return {
      items: [],
      event_id: this.$route.params.id,
      fields: [
        { key: 'position', label: 'N°', _style: 'width: 50px; font-size:12px;' },
        { key: 'name', label: 'Nombre', _style: 'font-size:12px;' },
        { key: 'last_name', label: 'Apellido', _style: 'font-size:12px;' },
        { key: 'nickname', label: 'Apodo', _style: 'font-size:12px;' },
        { key: 'phone', label: 'Whatsapp', _style: 'font-size:12px;' },
        { key: 'email', label: 'Email', _style: 'font-size:12px;' },
        { key: 'blacklist_date_human', label: 'Fecha PARAR', _style: 'font-size:12px;' }
      ]
    }
  },
  mounted() {
    this.loadBlacklist();
  },
  methods: {
    async loadBlacklist() {
      this.loading();

      const response = await ws.getBlacklist({ event_id: this.event_id });

      if (response.type === 'success') {
        this.items = response.data;
      }

      this.loaded();
    },
    loading() { store.commit('loading'); },
    loaded() { store.commit('loaded'); }
  }
}
</script>
